import { Documents } from "./Documents";

// The `uploads` template (page slug "documents") is the Documents page for
// every room since 2026-09-07 (Bill: the Hush Crib layout is the base for all
// rooms). The `data.layout = "explorer"` opt-in flag and the legacy drop-box
// page are gone; a stored `layout` key is ignored.
export const Uploads = Documents;
